import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const EclipseAiRecommendationStoreExtension = ModuleExtensions.storeExtension({
  isCollapsed: false,
  isDeciding: false,
  isRevealed: false,
  plansRendered: false,
  recommendedProductId: ''
}, 'aiRecommendationStore', {
  useIsCollapsed: state => state.isCollapsed,
  useIsDeciding: state => state.isDeciding,
  useIsRevealed: state => state.isRevealed,
  useArePlansRendered: state => state.plansRendered,
  useRecommendedProductId: state => state.recommendedProductId
}, {
  setRecommendedProductId: (_ref, recommendedProductId) => {
    let {
      draft
    } = _ref;
    draft.recommendedProductId = recommendedProductId;
  },
  markPlansRendered: _ref2 => {
    let {
      draft
    } = _ref2;
    draft.plansRendered = true;
  },
  decide: _ref3 => {
    let {
      draft
    } = _ref3;
    draft.isDeciding = true;
  },
  reveal: _ref4 => {
    let {
      draft
    } = _ref4;
    draft.isDeciding = false;
    draft.isRevealed = true;
  },
  collapse: _ref5 => {
    let {
      draft
    } = _ref5;
    draft.isCollapsed = true;
  },
  expand: _ref6 => {
    let {
      draft
    } = _ref6;
    draft.isCollapsed = false;
  }
});
//# sourceMappingURL=aiRecommendationStore.extension.js.map